import React, { Component } from 'react';
import IphoneUI from './iPhoneUI';

class IphonePage extends Component{
  constructor(props) {
    super(props);
    this.state = {isToggleOn: true};
    // 为了在回调中使用 `this`，这个绑定是必不可少的
    this.downLoad = this.downLoad.bind(this);
  }

  render() {
    return (
      <div className="content-wrapper iphone-wrapper">
        <div className="logo-wrapper">
          <div className="logo"></div>
          <div className="title">果加智能</div>
        </div>
        <div className="button-wrapper">
          <div className="link-button" onClick={this.downLoad}>
            <div className="button-icon"></div>
            <div className="text">iOS版下载</div>
          </div>
        </div>
      </div>
    );
  }

  downLoad() {
    window.location = 'https://apps.apple.com/app/id1475085137'; // Appstore下载应用
  }
}

export default IphonePage